module.exports = __webpack_public_path__ + "static/media/nexalyn-starter-package.271e1002.png";